module.exports = __webpack_public_path__ + "static/media/pre-launch-animation-final-HQ.2659ad2c.mp4";